import React, { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import NotificationDropdown from './NotificationDropdown';
import { fetchUnreadNotifications } from '../../apis/NotificationsApi';
import { FaBell } from "react-icons/fa";
import { io } from 'socket.io-client';
import './NotificationBell.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// Socket debe conectar al dominio base, no al prefijo /api
const SOCKET_URL = API_BASE_URL ? API_BASE_URL.replace(/\/api$/, '') : undefined;

export default function NotificationBell({ userId }) {
   if (!SOCKET_URL) {
    console.error("❌ NotificationBell: REACT_APP_API_BASE_URL is not defined or invalid.");
  }
  const [open, setOpen] = React.useState(false);
  const queryClient = useQueryClient();

  const { data: unreadData = { data: [] }, refetch } = useQuery({
    queryKey: ['unreadNotifications', userId],
    queryFn: () => fetchUnreadNotifications(userId, 1, 100),
    staleTime: Infinity, // Los datos se consideran frescos indefinidamente hasta que el Socket invalide
  });

  useEffect(() => {
    if (!SOCKET_URL) return;
    
    // Inicializar socket con el dominio base del backend
    const socket = io(SOCKET_URL);

    socket.on('connect', () => {
      if (userId) {
        socket.emit('join', { user_id: userId });
      }
    });

    socket.on('notifications_update', (payload) => {
      // Solo invalidar si la notificación es para este usuario (o si es global)
      if (!payload.user_id || payload.user_id === userId) {
        // TODO: remove console log after testing
        console.log("🔔 WebSocket: Nueva notificación recibida, actualizando...");
        queryClient.invalidateQueries(['unreadNotifications', userId]);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [userId, queryClient]);

  const unreadCount = unreadData.data ? unreadData.data.length : 0;

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(!open)}
        className='notification-bell'
      >
        <FaBell size={18} style={{color: 'rgb(67, 5, 68)'}}/>
        {unreadCount > 0 && (
          <span className='unread-badge'>
            {unreadCount}
          </span>
        )}
      </button>

      {open && (
        <NotificationDropdown userId={userId} onClose={() => setOpen(false)} onUpdate={refetch} />
      )}
    </div>
  );
}
